if (!customElements.get('axd-blog-shop')) {
  customElements.define('axd-blog-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      this.dataset.enhanced = 'true';
      const panel = this.querySelector('.axd-blog-shop__panel');
      const aside = this.querySelector('aside');
      const dialog = this.querySelector('dialog');
      const launch = this.querySelector('[data-open]');
      const mobile = matchMedia('(max-width:1099px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
      const rotation = this.querySelector('[data-rotation]');
      let paused = reducedMotion.matches;
      let keyboardPaused = false;
      let nextRotation = Date.now() + 6000;
      const resetRotation = () => { nextRotation = Date.now() + 6000; };
      const updateRotation = () => {
        rotation.textContent = paused ? rotation.dataset.playLabel : rotation.dataset.pauseLabel;
      };
      rotation.addEventListener('click', () => {
        paused = !paused;
        keyboardPaused = paused;
        resetRotation();
        updateRotation();
      });
      this.addEventListener('pointerenter', resetRotation);
      this.addEventListener('pointerleave', resetRotation);
      this.addEventListener('focusin', (event) => {
        if (event.target !== rotation) keyboardPaused = true;
      });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) {
          keyboardPaused = false;
          resetRotation();
        }
      });
      this.addEventListener('click', resetRotation);
      this.motionChanged = () => {
        if (reducedMotion.matches) paused = true;
        resetRotation();
        updateRotation();
      };
      reducedMotion.addEventListener('change', this.motionChanged);
      this.reducedMotion = reducedMotion;
      this.rotationTimer = setInterval(() => {
        if (mobile.matches || paused || keyboardPaused || document.hidden || this.matches(':hover') || Date.now() < nextRotation) return;
        const bounds = aside.getBoundingClientRect();
        if (bounds.bottom <= 0 || bounds.top >= innerHeight) return;
        const group = [...this.querySelectorAll('.axd-blog-shop__group')].find(item => !item.hidden);
        const track = group?.querySelector('.axd-blog-shop__track');
        if (!track || track.children.length < 2 || !track.clientWidth) return;
        const width = track.children[0].getBoundingClientRect().width + 16;
        const index = Math.round(track.scrollLeft / width);
        track.scrollTo({left: ((index + 1) % track.children.length) * width, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
        resetRotation();
      }, 500);
      updateRotation();
      const sync = () => {
        if (!mobile.matches) {
          if (dialog.open) dialog.close();
          aside.append(panel);
        } else if (!dialog.open) dialog.append(panel);
      };
      launch.addEventListener('click', () => {
        dialog.append(panel);
        dialog.showModal();
        this.querySelector('[data-close]').focus();
        this.updateAll();
      });
      this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => launch.focus());
      mobile.addEventListener('change', sync);
      const tabs = [...this.querySelectorAll('[data-tab]')];
      const select = (tab, focus = false) => {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          this.querySelector('#axd-shop-' + button.dataset.tab).hidden = !active;
        });
        if (focus) tab.focus();
        this.updateAll();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (event) => {
          let target = index;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = tabs.length - 1;
          else return;
          event.preventDefault();
          select(tabs[target], true);
        });
      });
      this.querySelectorAll('.axd-blog-shop__group').forEach(group => {
        const track = group.querySelector('.axd-blog-shop__track');
        const move = (direction) => {
          const width = track.querySelector('article')?.getBoundingClientRect().width || track.clientWidth;
          track.scrollBy({left: direction * (width + 16), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
        };
        group.querySelector('[data-prev]')?.addEventListener('click', () => move(-1));
        group.querySelector('[data-next]')?.addEventListener('click', () => move(1));
        track.addEventListener('scroll', () => this.updateGroup(group), {passive:true});
      });
      sync();
      this.updateAll();
      this.resizeObserver = new ResizeObserver(() => this.updateAll());
      this.resizeObserver.observe(this);
    }
    updateGroup(group) {
      if (group.hidden) return;
      const track = group.querySelector('.axd-blog-shop__track');
      const count = track.children.length;
      if (!count || !track.clientWidth) return;
      const width = track.children[0].getBoundingClientRect().width + 16;
      const index = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / width)));
      group.querySelector('[data-count]').textContent = (index + 1) + ' / ' + count;
      group.querySelector('[data-prev]').disabled = index === 0;
      group.querySelector('[data-next]').disabled = index === count - 1;
    }
    updateAll() { this.querySelectorAll('.axd-blog-shop__group').forEach(group => this.updateGroup(group)); }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      clearInterval(this.rotationTimer);
      this.reducedMotion?.removeEventListener('change', this.motionChanged);
    }
  });
}
